import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export type RemoveLeadFromAudienceParams = {
  audienceId: string;
  leadId: string;
};

export const removeLeadFromAudience = async (
  params: RemoveLeadFromAudienceParams,
): Promise<void> => {
  return await tinctApi.audiences.removeLeadFromAudience(params.audienceId, params.leadId);
};

export const useRemoveLeadFromAudience = (
  options?: Omit<
    UseMutationOptions<void, ApiError, RemoveLeadFromAudienceParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeLeadFromAudience,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['audiences'],
      });
      queryClient.invalidateQueries({
        queryKey: ['audience', args[1].audienceId],
      });
      queryClient.invalidateQueries({
        queryKey: ['campaigns'],
      });
      queryClient.invalidateQueries({
        queryKey: ['campaign'],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
